import * as State from 'components/desktop/Ingredient/IngredientState';
import { useHandler } from 'hooks/useHandler';

export default function useIngredientState(initial: State.Type) {
	const [state, rf] = useHandler<State.Type>(initial);
	return {
		state,
		handlers: {
			changeCharacteristic: rf.createReducerAsync(State.changeCharacteristic),
			getAndSetSuggestedTags: rf.createReducerAsync(State.getAndSetSuggestedTags),
			load: rf.createReducer(State.load),
			lock: rf.createReducer(State.lock),
			overwriteBaseIngredientKey: rf.createReducer(State.overwriteBaseIngredientValue),
			restoreBaseIngredientKey: rf.createReducer(State.restoreBaseIngredientValue),
			setAllergenIds: rf.createReducer(State.setAllergenIds),
			setBaseIngredientId: rf.createReducer(State.setBaseIngredientId),
			setCalories: rf.createReducer(State.setCalories),
			setCategories: rf.createReducer(State.setCategories),
			setCo2Footprints: rf.createReducer(State.setCo2Footprints),
			setDensity: rf.createReducer(State.setDensity),
			setDensityIsSetByUser: rf.createReducer(State.setDensityIsSetByUser),
			setHasNutriScore: rf.createReducer(State.setHasNutriScore),
			setNamePlural: rf.createReducer(State.setNamePlural),
			setNameSingular: rf.createReducer(State.setNameSingular),
			setNutriScoreCategory: rf.createReducer(State.setNutriScoreCategory),
			setNutriScoreCategoryIsSetByUser: rf.createReducer(
				State.setNutriScoreCategoryIsSetByUser
			),
			setNutrients: rf.createReducer(State.setNutrients),
			setPrice: rf.createReducer(State.setPrice),
			setProducts: rf.createReducer(State.setProducts),
			setScalingFactor: rf.createReducer(State.setScalingFactor),
			setSeasonIds: rf.createReducer(State.setSeasonIds),
			setSelectedCultureCode: rf.createReducer(State.setSelectedCultureCode),
			setSynonyms: rf.createReducer(State.setSynonyms),
			setTagIds: rf.createReducer(State.setTagIds),
			setUnitWeights: rf.createReducer(State.setUnitWeights),
			translateAndSetName: rf.createReducerAsync(State.translateAndSetName),
			translateAndSetNames: rf.createReducerAsync(State.translateAndSetNames),
			unlock: rf.createReducer(State.unlock),
			uploadImage: rf.createReducerAsync(State.uploadImage),
		},
	};
}

export type IngredientDetailHandlers = ReturnType<typeof useIngredientState>['handlers'];
